// extracted by mini-css-extract-plugin
export default {"title":"LodgingRoomCategoryDetails_title__1lPeB","edit":"LodgingRoomCategoryDetails_edit__ymt7Z","cancel":"LodgingRoomCategoryDetails_cancel__LRRLz"};